import { render } from "./NotAcceptResponse.vue?vue&type=template&id=854c90e6"
import script from "./NotAcceptResponse.vue?vue&type=script&lang=js"
export * from "./NotAcceptResponse.vue?vue&type=script&lang=js"

import "./NotAcceptResponse.vue?vue&type=style&index=0&id=854c90e6&lang=css"
script.render = render

export default script